import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_GROUPS } from '../get-groups';
import { updateGroupAPI } from './api';

export function useUpdateGroup() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation(({ id, group }) => updateGroupAPI(id, group), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_GROUPS, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'updateGroupSuccess' },
      });
    },
    onError: () => {
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'error', description: 'updateGroupFail' },
      });
    },
  });

  return {
    ...mutation,
  };
}

